const d = [
  "busbud",
  "recorrido",
  "terra",
  "terraos",
  "neredennereye",
  "virail",
  "flighthub",
  "justfly",
  "checkmybus",
  "walmart",
  "ahumada",
  "demo"
], i = [
  "red",
  "pink",
  "magenta",
  "purple",
  "indigo",
  "blue",
  "teal",
  "green",
  "grass",
  "yellow",
  "orange",
  "coral",
  "grey"
], p = {
  xs: "0px",
  sm: "600px",
  md: "768px",
  lg: "992px",
  xl: "1200px"
}, e = {
  appearance: "color",
  extension: "svg",
  size: "md",
  variant: "logo"
}, g = {
  logo: { sm: [24, "1.5rem"], md: [32, "2rem"], lg: [40, "2.5rem"] },
  avatar: { sm: [32, "2rem"], md: [40, "2.5rem"], lg: [48, "3rem"] }
}, m = ({
  brand: r,
  isInverted: o,
  appearance: a = e.appearance,
  extension: n = e.extension,
  size: s = e.size,
  variant: t = e.variant
}) => `https://busbud-pubweb-assets.global.ssl.fastly.net/horizon/BrandLogos/${r}/${t}-${a}${o ? "-inverted" : ""}-${s}.${n}`;
export {
  g as brandLogoHeightMap,
  m as buildBrandLogoUrl,
  e as defaultBrandLogoUrlConfigOptions,
  p as screenBreakpoints,
  d as supportedBrands,
  i as supportedColorPalettes
};
